import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const OrderSection = lazy(() => import('components/Sections/Order'))
const Footer = lazy(() => import('components/Layout/Footer'))

function Order() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <OrderSection />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default Order